module.exports = __webpack_public_path__ + "static/media/isp-bg-img.eb10cc43.png";